import type { RawCurrency } from "../../types";

/**
 * Interface for a clean currency information object, used by formatPrice.
 */
export interface CurrencyInfo {
  currencyMinorUnit?: number;
  currencyDecimalSeparator?: string;
  currencyThousandSeparator?: string;
  currencyPrefix?: string;
  currencySuffix?: string;
}

/**
 * Extracts currency formatting information from a raw API object.
 * @param source - An object conforming to the RawCurrency interface (like `totals` or `prices`).
 * @returns A clean CurrencyInfo object for use with formatPrice.
 */
export const extractCurrencyInfo = (source: RawCurrency): CurrencyInfo => {
  return {
    currencyMinorUnit: source.currency_minor_unit,
    currencyDecimalSeparator: source.currency_decimal_separator,
    currencyThousandSeparator: source.currency_thousand_separator,
    currencyPrefix: source.currency_prefix,
    currencySuffix: source.currency_suffix,
  };
};
